import React, { useState, useEffect } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Header from '../components/Header';
import axios from '../Axiosinstance';
import 'bootstrap/dist/css/bootstrap.min.css';
import { PDFDocument, rgb, StandardFonts } from 'pdf-lib';

import { toast, ToastContainer } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';
import courserecipt from '../pdf/courserecipt.pdf'
import 'jspdf-autotable';


const Fees = () => {
    const [search, setSearch] = useState('');
    // const [filter, setFilter] = useState('');
    const [details, setDetails] = useState(true);
    const [responseData, setResponseData] = useState(null);
    const [isSubmitted, setIsSubmitted] = useState(false);

    const [formData, setFormData] = useState({
        // invoiceNumber: "INV123456",
        date: '',
        studentName: '',
        finNric: '',
        course: '',
        description: '',
        amount: 0
    });
    // useEffect(() => {
    //     fetchData();
    // }, [itemsPerPage, currentPage]);

    const fetchData = async () => {
        try {
            // setLoading(true);
            const response = await axios.get('manage/search', {
                params: {
                    nric: search,
                }
            });
            const data = response.data;
            const currentDate = new Date().toISOString();
            if (data) {
                // Update formData with the fetched data
                setFormData({
                    date: currentDate,
                    studentName: data.sName || '',
                    finNric: data.nric || '',  // Ensure the property matches
                    course: data.course || '',
                    description: data.description || '',
                    amount: data.amount || 0
                });
            }
            setDetails(false);
            console.log("erf", response.data)
            // setTotalBatches(response.data.totalElements);
            // setLoading(false);
        } catch (error) {
            console.error('Error fetching :', error);
            // setLoading(false);
        }
    };

    const handleSearchChange = (e) => {
        setSearch(e.target.value);
    };

    const handleSearchClick = () => {
        // setCurrentPage(0); // Reset the current page to 0 when performing a new search

        if (search.trim() !== '') {
            fetchData(); // Call fetchData to perform the search
        } else {
            toast.error('Please enter a search term');
        }
    };


    const handleResetClick = () => {
        setSearch('');
        setDetails(true); // Reset to enable fields
        setFormData({
            date: '',
            studentName: '',
            finNric: '',
            course: '',
            description: '',
            amount: 0
        });
        setIsSubmitted(false);
    };



    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        const currentDate = new Date().toISOString(); // Get the current date in ISO format

        try {
            // Update the formData with the current date before submission
            const updatedFormData = {
                ...formData,
                date: currentDate
            };

            const response = await axios.post('registrationfees', formData); // Use the correct API endpoint
            console.log('Response:', response.data);
            setResponseData(response.data);
            toast.success('Form submitted successfully');
            setIsSubmitted(true);
        } catch (error) {
            console.error('Error submitting form:', error);
            toast.error('Failed to submit the form');
        }
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0'); // Get day and pad with leading zero if necessary
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based, so add 1 and pad
        const year = date.getFullYear(); // Get full year

        return `${day}.${month}.${year}`;
    };

    const numberToWords = (number) => {
        const ones = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
        const teens = ['', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
        const tens = ['', 'Ten', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
        const suffixes = ['', 'Thousand'];



        const numToWords = (num) => {
            let words = '';
            if (num >= 1000) {
                words += numToWords(Math.floor(num / 1000)) + ' thousand ';
                num %= 1000;
            }
            if (num >= 100) {
                words += ones[Math.floor(num / 100)] + ' hundred ';
                num %= 100;
            }
            if (num >= 20) {
                words += tens[Math.floor(num / 10)] + ' ';
                num %= 10;
            }
            if (num > 0) {
                if (num >= 11 && num <= 19) {
                    words += teens[num - 10] + ' ';
                } else {
                    words += ones[num] + ' ';
                }
            }
            return words.trim();
        };

        if (number === 0) return 'zero';
        return numToWords(number);
    };

    // const DateFormat = ({ dateStr }) => {
    //     const formatDate = (dateStr) => {
    //       const date = new Date(dateStr);
    //       const day = String(date.getDate()).padStart(2, '0');
    //       const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
    //       const year = date.getFullYear();

    //       return `${day}/${month}/${year}`;
    //     };

    const handleDownload = async (e) => {
        e.preventDefault(); // Prevent the default form submission behavior

        try {
            const pdfBytes = await fetch(courserecipt).then((res) => res.arrayBuffer());
            const pdfDoc = await PDFDocument.load(pdfBytes);

            const pages = pdfDoc.getPages();
            const firstPage = pages[0];

            // const courierfont = await pdfDoc.embedFont(StandardFonts.Courier);
            const courierfontbold = await pdfDoc.embedFont(StandardFonts.CourierBold);

            const amountText = responseData?.amount ? `$${responseData.amount}` : ''; // Ensure the dollar symbol is always present

            const sumOfDollars = numberToWords(responseData?.amount);
            // Convert numbers to strings
            firstPage.drawText(String(responseData?.studentName || '').toUpperCase(), { x: 130, y: 621, size: 11, font: courierfontbold, color: rgb(0, 0, 0) });
            firstPage.drawText(String(responseData?.finNric || ''), { x: 130, y: 598.5, size: 11, font: courierfontbold, color: rgb(0, 0, 0) });
            firstPage.drawText(String(responseData?.course || '').toUpperCase(), { x: 130, y: 578, size: 11, font: courierfontbold, color: rgb(0, 0, 0) });
            // firstPage.drawText(String(responseData?.description || ''), { x: 35, y: 520, size: 11, font: courierfontbold, color: rgb(0, 0, 0) });
            firstPage.drawText(String(responseData?.invoiceNumber || ''), { x: 497, y: 674, size: 11, font: courierfontbold, color: rgb(0, 0, 0) });
            firstPage.drawText(String(formatDate(responseData?.date || '')), { x: 420, y: 658, size: 11, font: courierfontbold, color: rgb(0, 0, 0) });
            firstPage.drawText(amountText, { x: 490, y: 520, size: 11, font: courierfontbold, color: rgb(0, 0, 0) });
            firstPage.drawText(amountText, { x: 490, y: 480, size: 11, font: courierfontbold, color: rgb(0, 0, 0) });
            firstPage.drawText(`${sumOfDollars} Dollars Only`, { x: 130, y: 477, size: 11, font: courierfontbold, color: rgb(0, 0, 0) });
            firstPage.drawText("AUD", { x: 490, y: 462, size: 11, font: courierfontbold, color: rgb(0, 0, 0) });


            const drawWrappedText = async (page, text, x, y, font, fontSize, maxWidth) => {
                text = replaceTabs(text);
                const lines = [];
                let currentLine = '';
                const words = text.split(' ');

                for (let i = 0; i < words.length; i++) {
                    const word = words[i];
                    const width = getTextWidth(currentLine + ' ' + word, font, fontSize);

                    if (width < maxWidth) {
                        currentLine += (currentLine === '' ? '' : ' ') + word;
                    } else {
                        lines.push(currentLine.trim());
                        currentLine = word;
                    }
                }

                if (currentLine !== '') {
                    lines.push(currentLine.trim());
                }

                for (let i = 0; i < lines.length; i++) {
                    const line = lines[i].trim();
                    const lineWidth = getTextWidth(line, font, fontSize);

                    await page.drawText(line, {
                        x: i === 0 ? x : x,
                        y: y - i * 12,
                        size: fontSize,
                        font,
                        color: rgb(0, 0, 0),
                    });
                }
            };

            function replaceTabs(text) {
                return text.replace(/\t/g, '    '); // Replace each tab with four spaces
            }

            const getTextWidth = (text, font, fontSize) => {
                const width = font.widthOfTextAtSize(text, fontSize);
                return width;
            };

            let yPosition = 520;
            const lineHeight = 10;

            drawWrappedText(firstPage, String(responseData?.description || ''), 35, yPosition, courierfontbold, 10, 380);
            yPosition -= lineHeight;


            const pdfBytesModified = await pdfDoc.save();
            const pdfBlob = new Blob([pdfBytesModified], { type: 'application/pdf' });
            const pdfUrl = URL.createObjectURL(pdfBlob);
            window.open(pdfUrl, '_blank');
        } catch (error) {
            console.error('Error generating PDF:', error);
            toast.error('Failed to generate PDF');
        }
    };


    return (
        <div>
            <Header />
            <div className="containerd" style={{ marginLeft: '24%', maxWidth: '1000px', padding: '20px', marginTop: '-20px', color: 'black', background: '#FAF9F6', borderRadius: '15px' }}>

                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
                    <input
                        type="text"
                        placeholder="Search by ID"
                        value={search}
                        onChange={handleSearchChange}
                        onKeyPress={(e) => {
                            if (e.key === 'Enter') {
                                handleSearchClick();
                            }
                        }}
                        style={{
                            padding: '10px',
                            border: '1px solid #ddd',
                            borderRadius: '4px',
                            flex: '1',
                            fontSize: '16px',
                            marginRight: '10px'
                        }}
                    />
                    <button className='btn btn-primary' onClick={handleSearchClick} style={{ padding: '10px 20px' }}>
                        Search
                    </button>
                    <button className='btn btn-secondary' onClick={handleResetClick} style={{ marginLeft: '10px', padding: '10px 20px' }}>
                        Reset
                    </button>
                </div>

                <h4 >Registration Fees(AEG International College)</h4>
                <hr style={{ marginTop: '1%' }} />

                <form

                    style={{ display: 'flex', flexDirection: 'row' }} >
                    <div style={{ marginRight: '20px', flex: 1 }}>
                        <div className="form-grup">
                            <label htmlFor="studentName">Student Name*</label>
                            <input
                                type="text"
                                style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}
                                id="StudentName"
                                className="form-control"
                                name="studentName"
                                value={formData.studentName}  // Corrected
                                onChange={handleChange}
                                required
                                disabled={!details}
                            />
                            {/* <label htmlFor="date">Date*</label>
                            <input
                                type="text"
                                style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}
                                id="date"
                                className="form-control"
                                value={formData.date}  // Corrected
                                onChange={handleChange}
                                required
                            /> */}

                            {/* <label htmlFor="InvoiceNo">Invoice No*</label>
                            <input
                                type="text"
                                style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}
                                id="InvoiceNo"
                                value={formData.invoiceNo}  // Corrected
                                onChange={handleChange}
                                className="form-control"
                                required
                            /> */}
                        </div>

                        <div className="form-group">
                            <label htmlFor="finNric">FIN/NRIC No*</label>
                            <input
                                type="text"
                                style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}
                                id="finNric"
                                name="finNric"
                                className="form-control"
                                value={formData.finNric}
                                onChange={handleChange}
                                disabled={!details}
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="course">Course</label>
                            <input
                                type="text"
                                style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}
                                id="course"
                                name="course"
                                className="form-control"
                                value={formData.course}
                                onChange={handleChange}
                                required
                                disabled={!details}
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="description">Description</label>
                            <input
                                type="text"
                                style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}
                                id="description"
                                name="description"
                                className="form-control"
                                value={formData.description}
                                onChange={handleChange}
                                required
                            />
                        </div>


                        <div className="form-group">
                            <label htmlFor="amount">Amount</label>
                            <input
                                type="number"
                                style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}
                                id="amount"
                                name="amount"
                                className="form-control"
                                value={formData.amount}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <br />
                        <button className="btn btn-secondary" onClick={handleSubmit} disabled={isSubmitted}>
                            submit
                        </button>
                        {isSubmitted && (
                            <button type="button" className="btn btn-secondary" onClick={handleDownload}>
                                View Receipt
                            </button>
                        )}

                    </div>
                </form>

                <ToastContainer position="bottom-right" autoClose={3000} hideProgressBar />
            </div>
        </div>
    );
};



export default Fees;
